import React from 'react'
import { Router } from './routes/Router'
import styled from 'styled-components'
import { Navbar } from './components/Navbar/Navbar'

const PageContainer = styled.div`
  position: absolute;
  top: 80px;
  width: 100%;
  background: #fff;
`
function App() {
  // Need to do this because window.runtimeConfig won't be initialized for tests
  // const { apiURL, testURL } = window.runtimeConfig ? window.runtimeConfig : {};

  return (
    <div className="App min-vh-100">
      <Navbar />
      <PageContainer>
        <Router />
      </PageContainer>
    </div>
  )
}

export default App
